import { Route, Routes, BrowserRouter as Router, useParams, useLocation } from "react-router-dom";
import React, { Suspense } from "react";
const Confdata = window['runConfig']

import EmailAuthentication from "../Routes/email-authentication-page";
import LoadingPage from "../components/loading-page-component";
import SubscriptionPage from "../Routes/subscription-page";
import Signup from "../Routes/Signup";
import { customLogs } from "../components/util/util";

// const EmailAuthentication = React.lazy(() => import("../Routes/email-authentication-page"))
// const LoadingPage = React.lazy(() => import('../components/loading-page-component'))
// const SubscriptionPage = React.lazy(() => import('../Routes/subscription-page'))
// const Signup = React.lazy(() => import('../Routes/Signup'))

const MainRouter = () => {

    customLogs("version - JodoSubScription_v1.0.20 08/04/2025")

    return (
        <>
            <Router basename={Confdata.jodostripebasename}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route path="/subscription/:serviceID" element={<EmailAuthentication />} />
                        <Route path="/subscription/:serviceID/loading" element={<LoadingPage />} />
                        <Route path="/subscription/:serviceID/subscription" element={<SubscriptionPage />} />
                        {/* <Route path="/subscription/:serviceID" element={<SubscriptionPage />} /> */}
                        <Route path="/jodoworldsignup/:userjson" element={<Signup />} />
                    </Routes>
                </Suspense>
            </Router>;
        </>
    )
}

export default MainRouter;


